<template>
  <div class="order-content">
    <div class="modal" id="order-confirmation" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <p>
              Niste zaključili trenutno stanje košarice. Da li ste sigurni da želite ponoviti ovu
              narudžbu?
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="confirmOrder(currentOrder)">
              {{ translations.yes }}
            </button>
            <button type="button" class="btn btn-primary" @click="closeConfirmationModal()">
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <h3 class="account-sub-title d-none d-md-block">
      <i class="sicon-social-dropbox align-middle mr-3"></i>
      {{ translations.orders }}
    </h3>
    <div class="date-range-wrapper d-flex flex-wrap flex-md-nowrap">
      <date-picker
        :placeholder="translations.from"
        v-model="dateFrom"
        :ranges="false"
        :disabled-date="disabledDatesFromDate"
        :clearable="false"
        input-class="form-control"
        format="DD.MM.YYYY"
      />

      <date-picker
        :placeholder="translations.to"
        :ranges="false"
        v-model="dateTo"
        :disabled-date="disabledDatesToDate"
        :clearable="false"
        input-class="form-control"
        format="DD.MM.YYYY"
      />

      <div class="select-custom">
        <select v-model="orderStatus" class="form-control mb-0">
          <option :value="null">Sve</option>
          <option v-bind:key="obj.id" v-for="obj in statuses" :value="obj.id">
            {{ obj.title }}
          </option>
        </select>
      </div>
      <div>
        <input class="form-control" placeholder="Pretraga" v-model="searchConfig.quickSearch" />
      </div>
      <button
        type="button"
        class="btn btn-primary text-transform-none mb-1 ml-md-auto"
        @click.stop.prevent="getOrders"
      >
      {{ translations.show.toUpperCase() }}
      </button>
    </div>
    <div class="order-table-container order-table-with-content">
      <table class="table table-order text-left">
        <thead>
          <tr>
            <th class="order-id">{{ translations.ord.toUpperCase() }}</th>
            <th class="order-id">{{ translations.orderNumber.toUpperCase() }}</th>
            <th class="order-id">{{ translations.orderer.toUpperCase() }}</th>
            <th class="order-date">{{ translations.date.toUpperCase() }}</th>
            <th class="order-status">{{ translations.status.toUpperCase() }}</th>
            <th class="order-price" v-if="canViewPrices">
              {{ translations.amountWithoutVat.toUpperCase() }}</th>
            <th class="order-price" v-if="canViewPrices">
              {{ translations.vatAmount.toUpperCase() }}</th>
            <th class="order-price" v-if="canViewPrices">{{ translations.total.toUpperCase() }}</th>
            <th class="order-price" v-if="canViewPrices">
              {{ translations.delivery.toUpperCase() }}</th>
            <th class="order-price" v-if="canViewPrices">
              {{ translations.totalAmountWithDelivery.toUpperCase() }}</th>
            <th class="order-action">{{ translations.actions.toUpperCase() }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="orders.length === 0">
            <td class="text-center p-0" colspan="5">
              <p class="mb-5 mt-5">{{ translations.youHaveNotPlacedAnorderYet }}.</p>
            </td>
          </tr>
          <tr class="pending-order" v-for="(item, index) in orders" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>{{ item.id }}</td>
            <td>{{ `${item.user.firstName} ${item.user.lastName}` }}</td>
            <td>{{ formatMomentDate(item.createdDate) }}</td>
            <td>
              <span :class="[item.status == 1 ? 'status-created' :
                item.status == 2 || item.status == 10 ? 'status-over' : 'status-ongoing']">
                {{ mapOrderStatus(item.status) }}
              </span>
            </td>
            <td v-if="canViewPrices">{{ item.totalWithoutVat.toFixed(2).replace('.', ',') }}</td>
            <td v-if="canViewPrices">{{ item.totalVat.toFixed(2).replace('.', ',') }}</td>
            <td v-if="canViewPrices">{{ item.totalAmount.toFixed(2).replace('.', ',') }}</td>
            <td v-if="canViewPrices">{{ item.transportPrice.toFixed(2).replace('.', ',') }}</td>
            <td v-if="canViewPrices">
              {{ (item.totalAmount + item.transportPrice).toFixed(2).replace('.', ',') }} KM
            </td>
            <td class="order-actions">
              <a href="#" title="Prikaži stavke" @click.prevent="getOrder(item.id)">
                <i class="fas fa-external-link-alt"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <pagination :action="actionName" :pagination-props="paginationProps" />
      <hr class="mt-0 mb-3 pb-2" v-if="orders.length === 0" />
      <router-link exact :to="{ name: 'Home' }" class="btn btn-primary">
        {{ translations.continueShopping }}
      </router-link>

      <div
        class="modal fade"
        id="show-order-items"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        v-if="order"
      >
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                <span>{{ translations.orderNo }}.: {{ order.id }}</span>
                <span>{{ translations.time }}: {{ formatMomentDate(order.createdDate) }}</span>
                <span :class="[order.status == 1 ? 'status-created' :
                order.status == 2 || order.status == 10 ? 'status-over' : 'status-ongoing']">
                  {{ translations.status }}: {{ mapOrderStatus(order.status) }}
                </span>
              </h4>
              <div
                v-if="
                  (profile?.userData?.canApproveOrder === true || canManageOrder === true) &&
                  order.status === -1
                "
              >
                <button type="button" class="btn btn-primary" @click="showOrderApprovingModal">
                  {{ translations.approveOrd }}.
                </button>
                <button type="button" class="btn ml-1" @click="showOrderCancellingModal">
                  {{ translations.rejectOrd }}.
                </button>
              </div>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-9">
                  <div class="cart-table-container">
                    <div class="table-product-list">
                      <table class="table text-left">
                        <thead>
                          <tr>
                            <th>{{ translations.manufacturer }}</th>
                            <th>{{ translations.forms.labels.code }}</th>
                            <th>{{ translations.productName }}</th>
                            <th>{{ translations.preview }}</th>
                            <th v-if="canViewPrices">{{ translations.vpc }}</th>
                            <th>{{ translations.quantity }}</th>
                            <th v-if="canViewPrices">{{ translations.discount }}</th>
                            <th v-if="canViewPrices">{{ translations.totalWithVat }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in order.orderItems" :key="item.id">
                            <td>
                              {{ item.brand }}
                            </td>
                            <td>
                              {{ item.articleCode }}
                            </td>
                            <td style="max-width: 250px">
                              {{ item.article }}
                            </td>
                            <td>
                              <img
                                class="small-product-list-img"
                                :src="`${baseUrl}${item.articleImageUrl}`"
                              />
                            </td>
                            <td v-if="canViewPrices">
                              {{ item.articleVPC.toFixed(2).replace('.', ',') }}
                            </td>
                            <td>{{ item.quantity.toFixed(2).replace('.', ',') }}</td>
                            <td v-if="canViewPrices">
                              {{
                                ((1 - item.price / item.articleVPC) * 100)
                                  .toFixed(2)
                                  .replace('.', ',')
                              }}%
                            </td>
                            <td v-if="canViewPrices">
                              {{ item.totalAmount.toFixed(2).replace('.', ',') }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- End .cart-table-container -->
                </div>
                <!-- End .col-lg-8 -->
                <div class="col-lg-3">

                  <div class="cart-summary" style="margin-bottom: 4px;" v-if="canViewPrices">
                    <h3>{{ translations.summary }}</h3>
                    <table class="table table-totals"
                    style="margin:0;">
                      <tbody>
                        <tr>
                          <td>{{ translations.totalWithoutVat2 }}</td>
                          <td>{{ order.totalWithoutVat.toFixed(2).replace('.', ',') }}</td>
                        </tr>
                        <tr>
                          <td>+ {{ translations.tax }}</td>
                          <td>{{ order.totalVat.toFixed(2).replace('.', ',') }}</td>
                        </tr>
                      </tbody>
                      </table>
                      <!-- promo kod -->
                      <table class="table table-totals"
                        style="border: none !important; margin:0;"
                        v-if="order.promoCode && order.promoCode.discountApplianceType === 1 ">
                        <tbody style="border: none !important; margin:0;">
                          <tr>
                            <td>{{ translations.totalWithVat }}:</td>
                            <td>{{ (order.totalWithoutVat + order.totalVat).toFixed(2) }}</td>
                          </tr>
                          <tr>
                            <td>- {{ translations.promoCode }}</td>
                            <td>-{{ order.discountCodeAmount.toFixed(2) }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <!-- promo kod -->
                      <!-- poklon kod -->
                      <table class="table table-totals"
                        style="border: none !important; margin:0;"
                        v-if="order.giftCard">
                        <tbody style="border: none !important; margin:0;">
                          <tr>
                            <td>{{ translations.totalWithVat }}:</td>
                            <td>{{ (order.totalWithoutVat + order.totalVat).toFixed(2) }}</td>
                          </tr>
                          <tr>
                            <td>- {{ translations.giftCard }}</td>
                            <td>-{{ order.discountCodeAmount.toFixed(2) }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <!-- poklon kod -->
                      <table class="table table-totals">
                      <tfoot style="border-top: 1px solid #ddd">
                        <tr>
                          <td>{{ translations.total }}</td>
                          <td>{{ order.totalAmount.toFixed(2).replace('.', ',') }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #ddd">
                          <td style="padding-top: 0px; font-size: 13px">
                            {{ translations.delivery }}</td>
                          <td style="padding-top: 0px; font-size: 13px">
                            {{ order.transportPrice.toFixed(2).replace('.', ',') }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ translations.totalAmountWithDelivery }}</td>
                          <td>
                            {{
                              (order.totalAmount + order.transportPrice)
                                .toFixed(2)
                                .replace('.', ',')
                            }}
                            KM
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  <div v-if="order.promoCode
                    && order.promoCode.discountApplianceType !== 1"
                    class="d-flex justify-content-center align-items-center">
                    <span>
                      *{{ translations.savingsByUsingPromoCode }}:
                       {{ order.discountCodeAmount.toFixed(2) }} KM
                    </span>
                  </div>
                  <!-- End .cart-summary -->

                  <div class="checkout-info-box" style="margin-top:20px;">
                    <h3 class="step-title">{{ translations.deliverTo }}:</h3>
                    <address>
                      {{ order.shippingAddress.firstName }}
                      {{ order.shippingAddress.lastName }} <br />
                      {{ order.shippingAddress.address }}, <br />
                      {{ order.shippingAddress.town }}, {{ order.shippingAddress.country }},
                      {{ order.shippingAddress.zipCode }} <br />
                      {{ order.shippingAddress.country }} <br />
                      {{ order.shippingAddress.phoneNumber }} <br />
                    </address>
                  </div>
                  <!-- End .checkout-info-box -->
                </div>
                <!-- End .col-lg-4 -->
              </div>
              <!-- End .row -->
            </div>
            <div class="modal-footer">
              <button type="button" class="btn" data-dismiss="modal">
                {{ translations.close }}</button>
              <button type="button" class="btn btn-primary" @click="repeatOrder(order)">
                {{ translations.repeatOrder}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" id="order-cancel-confirmation" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <p>{{ translations.areYouSureCancelOrder }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="updateOrderStatus(3)">
              {{ translations.yes }}</button>
            <button type="button" class="btn btn-primary" @click="closeOrderCancellingModal()">
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" id="order-approve-confirmation" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <p>{{ translations.areYouSureApproveOrder }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="updateOrderStatus(1)">
              {{ translations.yes }}</button>
            <button type="button" class="btn btn-primary" @click="closeOrderApprovingModal()">
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import { format } from 'date-fns';

import config from '@/config';
import api from '@/services/api';
import { pager, translations } from '@/mixins';
import Pagination from '@/components/shared/Pagination.vue';
import helpers from '@/services/helpers';

const dateInPast = new Date();
dateInPast.setDate(dateInPast.getDate() - 60);

export default {
  name: 'Orders',
  mixins: [pager, translations],
  components: {
    DatePicker,
    Pagination,
  },
  data() {
    return {
      actionName: 'getOrders',
      currentOrder: null,
      dateFrom: new Date(moment(dateInPast)),
      dateTo: new Date(moment()),
      orderStatus: null,
    };
  },
  computed: {
    statuses() {
      return helpers.OrderStatuses;
    },
    orders() {
      return this.$store.getters.getOrders;
    },
    order() {
      return this.$store.getters.getOrder;
    },
    baseUrl() {
      return config.baseUrl;
    },
    loggedUser() {
      return this.$store.getters.getLoggedUser;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canManageOrder() {
      return (
        (
          this.$store.getters.getLoggedUser.permissions
          ?? JSON.parse(localStorage.getItem('profile-main')).permissions
        ).filter((x) => x === 'Can Approve Orders').length === 1
      );
    },
    cart() {
      return this.$store.getters.getShoppingCart;
    },
    showConfirmationModal() {
      const { cart } = this;
      return cart?.cartItems?.length > 0;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
    paginationProps() {
      return {
        pageSize: this.searchConfig.pageSize,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      };
    },
  },
  methods: {
    format(dateString) {
      return format(new Date(dateString), 'dd.MM.yyyy HH:mm');
    },
    formatMomentDate(date, dateFormat = 'DD.MM.yyyy, HH:mm') {
      const formattedDate = moment.utc(date).local().format(dateFormat);
      return formattedDate;
    },
    updateOrderStatus(status) {
      api
        .updateOrderStatus({
          orderId: this.order !== undefined ? this.order.id : 0,
          status,
          b2b: true,
        })
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .finally(() => {
          $('#show-order-items').modal('hide');

          this.$store.dispatch('getOrder', this.order.id);
          if (status === 3) {
            this.closeOrderCancellingModal();
          } else {
            this.closeOrderApprovingModal();
          }
          this.getOrders();
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info);
        });
    },
    mapOrderStatus(status) {
      if (helpers.orderStatusesObject[status]) {
        return helpers.orderStatusesObject[status];
      }

      return 'N/A';
    },
    disabledDatesFromDate(date) {
      const currentDate = new Date();

      return date > currentDate || date > this.dateTo;
    },
    disabledDatesToDate(date) {
      const currentDate = new Date();

      return date < this.dateFrom || date > currentDate;
    },
    getOrder(id) {
      this.$store.dispatch('getOrder', id).then(() => {
        $('#show-order-items').modal('show');
      });
    },
    closeModal() {
      $('#show-order-items').modal('hide');
    },
    closeConfirmationModal() {
      $('#order-confirmation').modal('hide');
    },
    showOrderConfirmationModal() {
      $('#order-confirmation').modal('show');
    },
    closeOrderCancellingModal() {
      $('#order-cancel-confirmation').modal('hide');
    },
    showOrderCancellingModal() {
      $('#order-cancel-confirmation').modal('show');
    },
    closeOrderApprovingModal() {
      $('#order-approve-confirmation').modal('hide');
    },
    showOrderApprovingModal() {
      $('#order-approve-confirmation').modal('show');
    },
    confirmOrder(order) {
      api
        .repeatOrder(order.id)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info);
        })
        .finally(() => {
          this.closeModal();
          this.$store.dispatch('getShoppingCart');
          $('#order-confirmation').modal('hide');
        });
    },
    repeatOrder(order) {
      this.currentOrder = order;
      if (this.showConfirmationModal) {
        this.showOrderConfirmationModal();
        return;
      }
      this.confirmOrder(order);
    },
    getOrders() {
      this.$store
        .dispatch(this.actionName, {
          ...this.searchConfig,
          dateFrom: moment(this.dateFrom).format('YYYY-MM-DDT00:00:00Z'),
          dateTo: moment(this.dateTo).format('YYYY-MM-DDT23:59:59Z'),
          orderStatus: this.orderStatus,
        })
        .then(() => {
          const { query } = this.$route;
          if (query['modal-open'] && query['modal-open'] === 'true' && query['order-id']) {
            this.getOrder(query['order-id']);
            this.orderStatus = null;
            this.$router.replace({ query: {} });
          }
        });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const { query } = this.$route;
    if (query['date-from']) {
      this.dateFrom = new Date(query['date-from']);
    }
    if (query['date-to']) {
      this.dateTo = new Date(query['date-to']);
    }
    this.getOrders();
  },
};
</script>

<style lang="scss">
.attribute-style-1 {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-bottom: -5px;
}

#order-confirmation {
  z-index: 1100;
}

.date-range-wrapper {
  display: flex;
  align-items: center;
  gap: 1rem;
}
</style>
